window.addEventListener('load', function() {
    const thumbsSlider = new Swiper("#CollectionRange-Info .thumbsSlider", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            // when window width is >= 751px
            751: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
        }
    });
    const mainSlider = new Swiper("#CollectionRange-Info .mainSlider", {
        spaceBetween: 10,
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: thumbsSlider,
        },
    });
});